<template>
  <el-container class="abnormal-page">
    <el-header class="page-header">
      <div class="header-row">
        <div class="Time">{{getTime}}</div>
        <div>
          {{selectedProject.name}}
        </div>
      </div>
    </el-header>

    <el-main class="page-main">
      <el-row :gutter="20">
        <!-- 左側資訊欄 -->
        <el-col :span="12">
          <div class="info-stack">
            <el-card shadow="never" class="info-block">
              <div class="block-title">最新施工進度 
                <!-- 右側「新增」按鈕 -->
                <el-button
                  class="new-btn"
                  type="primary"
                  size="mini"
                  @click="openCreateContructionProcessAnn"
                >
                  新增
                </el-button>
              </div>
              <ul class="dotted-list">
                <li v-if="processTable.length === 0">&lt;空&gt;</li>
                <li 
                  v-for="(item, index) in processTable.slice(0, 2)" 
                  :key="'p' + index"
                  @click="showDetail(item, '最新施工進度')"
                  class="list-item"
                >
                  <!--{{ item.title }} <span class="date">{{ item.date }}</span>-->
                  <span class="rich-title" v-html="safeHtml(item.title)"></span>
                  <span class="date">{{ item.date }}</span>
                </li>
                <li v-if="processTable.length > 2">
                  <a href="#" @click.prevent="openProcessList">...(閱讀更多)</a>
                </li>
              </ul>
            </el-card>

            <el-card shadow="never" class="info-block">
              <div class="block-title">軟體系統公告 
                <!-- 右側「新增」按鈕 -->
                <el-button
                  class="new-btn"
                  type="primary"
                  size="mini"
                  @click="openCreateSoftwareSystemAnn"
                >
                  新增
                </el-button>
              </div>
              <ul class="dotted-list">
                <li v-if="softwareTable.length === 0">&lt;空&gt;</li>
                <li 
                  v-for="(item, index) in softwareTable.slice(0, 2)" 
                  :key="'s' + index"
                  @click="showDetail(item, '軟體系統公告')"
                  class="list-item"
                >
                <!--li v-for="(item, index) in softwareTable.slice(0, 2)" :key="'s' + index"-->
                  <!--{{ item.title }} <span class="date">{{ item.date }}</span>-->
                  <span class="rich-title" v-html="safeHtml(item.title)"></span>
                  <span class="date">{{ item.date }}</span>
                </li>
                <li v-if="softwareTable.length > 2">
                  <a href="#" @click.prevent="openSoftwareList">...(閱讀更多)</a>
                </li>
              </ul>
            </el-card>

            <el-card shadow="never" class="info-block">
              <div class="block-title">個人通知</div>
              <ul class="dotted-list">
                <li v-if="noticeTable.length === 0">&lt;空&gt;</li>
                <li 
                  v-for="(item, index) in noticeTable.slice(0, 2)" 
                  :key="'n' + index"
                  @click="showDetail(item, '個人通知')"
                  class="list-item"
                >
                <!--li v-for="(item, index) in noticeTable.slice(0, 2)" :key="'n' + index"-->
                  {{ item.title }} <span class="date">{{ item.date }}</span>
                </li>
                <li v-if="noticeTable.length > 2">
                  <a href="#">...(閱讀更多)</a>
                </li>
              </ul>
            </el-card>
          </div>
        </el-col>

        <!-- 右側儀器清單欄 -->
        <SMS 
          @componentMounted="handleComponentMounted" 
          :type="'KMRT'"
        >
        </SMS>

        
        <!-- 進度上傳 Dialog -->
        <el-dialog
          :visible.sync="editDialogVisible"
          width="1200px"
          class="process-create-dialog"
          :show-close="false"
          :modal="true"
          :close-on-click-modal="false"
        >
          <!-- 自訂 header -->
          <template #title>
            <div class="dialog-header">
              <div class="header-left">
                <span class="label">日期：</span>
                <el-date-picker
                  v-model="form.date"
                  type="date"
                  format="yyyy/M/d"
                  value-format="yyyy/M/d"
                  size="small"
                />
              </div>
              <div class="actions">
                <el-button
                  size="mini"
                  type="primary"
                  @click="handleUpload"
                  :loading="uploading"
                >
                  {{ editingId ? '更新' : '上傳' }}
                </el-button>
                <i class="el-icon-close close-x" @click="editDialogVisible = false"></i>
              </div>
            </div>
          </template>
          <!-- 內容區：Quill 編輯器 -->
          <quill-editor
            v-model="form.content"
            :options="editorOptions"
            class="editor"
          />
        </el-dialog>

        <ann-table-dialog
          :visible.sync="listDialog.visible"
          :title="listDialog.title"
          :rows="listRows"
          @select="onListSelect"
        />
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import AnnTableDialog from '@/components/dashboard/AnnTableDialog.vue';
import SMS from './SMS.vue';
import DOMPurify from 'dompurify';

const NOTICE_CONTENT_MAX = 10000;

export default {
  name: 'AbnormalInstrumentList',
  components: {
    quillEditor,
    AnnTableDialog,
    SMS,
  },
  data() {
    return {
      filterType: '本日',
      showWarning: true,
      showAction: true,
      uploading: false,
      time : null,
      processTable:[ ],
      softwareTable:[ ],
      noticeTable:[ ],
      
      dialogEditTarget: '',
      editDialogVisible: false,
      editorOptions: {
        theme: 'snow',
        placeholder: '在此輸入進度內容',
      },
      form: {
        date: '',     // yyyy/M/d
        content: '',  // html
      },

      editingId: '',   // 非空字串代表目前是「編輯」而非「新增」

      listDialog: {
        visible: false,
        title: '',
        detailTitle: '',
        target: '',     // 'process' | 'software'
      }, // 共用狀態

      apiDict: {
        CreateSoftwareSystemAnn    : 'createSoftwareNotice',
        CreateContructionProcessAnn: 'createProcessNotice' ,
      },
      // 編輯 API（需與後端對應）
      updateApiDict: {
        CreateSoftwareSystemAnn    : 'updateSoftwareNotice',
        CreateContructionProcessAnn: 'updateProcessNotice' ,
      },
      // 詳細內容標題 → 編輯目標；個人通知不在其中，代表不可編輯
      detailEditTargets: {
        '最新施工進度': 'CreateContructionProcessAnn',
        '軟體系統公告': 'CreateSoftwareSystemAnn',
      },
    };
  },
  computed: {
    selectedProject() {
      return this.$store.getters['project/selectedProject'];
    },
    getTime(){
      if(!this.time) return '';
      return this.time;
    },
    isAdmin() {
      return this.$store.getters['user/isAdmin'];
    },
    listRows() {
      if (this.listDialog.target === 'process') return this.processTable;
      if (this.listDialog.target === 'software') return this.softwareTable;
      return [];
    },
  },
  mounted() {
    this.time = new Date().toLocaleString();
    this.sortTable();
    console.log('Admin : ', this.isAdmin);
    this.loadAll();
  },
  methods: {
    safeHtml(raw){
      return DOMPurify.sanitize(raw, {
        ALLOWED_TAGS: ['p','br','strong','em','u','s','span'],
        ALLOWED_ATTR: ['style','class'],
      });
    },
    sortTable() {
      this.processTable = this.processTable.sort((a,b)=>{
        return new Date(b.date) - new Date(a.date);
      });
      this.softwareTable = this.softwareTable.sort((a,b)=>{
        return new Date(b.date) - new Date(a.date);
      });
      this.noticeTable = this.noticeTable.sort((a,b)=>{
        return new Date(b.date) - new Date(a.date);
      });
    },
    openCreateContructionProcessAnn() {
      console.log('openCreateContructionProcessAnn');
      this.form = { date: '', content: '' };
      this.editingId = '';
      this.editDialogVisible = true;
      this.dialogEditTarget = 'CreateContructionProcessAnn';
    },
    openCreateSoftwareSystemAnn() {
      console.log('openCreateSoftwareSystemAnn');
      this.form = { date: '', content: '' };
      this.editingId = '';
      this.editDialogVisible = true;
      this.dialogEditTarget = 'CreateSoftwareSystemAnn';
    },
    showDetail(item, title) {
      const editTarget = this.detailEditTargets[title];

      // 個人通知為純文字，維持原本去標籤顯示，且不提供編輯
      if (!editTarget) {
        this.$alert(`
        ${item.date} ${this.stripHtmlTags(item.title)}。
      `, title, {
          customClass: 'process-alert',
          center: false,         // 跟範例截圖一樣左靠
          showClose: true,       // 右上角關閉 X
          confirmButtonText: '關閉',
        });
        return;
      }

      // 其餘公告為 Quill 富文本，過濾後以 HTML 顯示；「編輯」置於「關閉」旁
      const msg = `<div class="rich-content"><p><strong>${item.date}</strong></p>${this.safeHtml(item.title)}</div>`;
      this.$confirm(msg, title, {
        dangerouslyUseHTMLString: true,
        customClass: 'process-alert rich-alert',
        center: false,
        showClose: true,
        confirmButtonText: '關閉',
        cancelButtonText: '編輯',
        cancelButtonClass: 'rich-alert-edit-btn',
        closeOnClickModal: true,         // 點視窗外直接關閉
        distinguishCancelAndClose: true, // 區分「編輯」(cancel) 與 X／點外面／Esc (close)
      }).catch(action => {
        if (action === 'cancel') this.openEditAnn(item, editTarget);
      });
    },
    /* 施工進度 */
    openProcessList(){
      this.listDialog = {
        visible: true,
        title  : '最新施工進度 (30 天內)',
        detailTitle: '最新施工進度',
        target : 'process',
      };
    },
    /* 軟體公告 */
    openSoftwareList(){
      this.listDialog = {
        visible: true,
        title  : '軟體系統公告 (30 天內)',
        detailTitle: '軟體系統公告',
        target : 'software',
      };
    },
    /* 列表對話框點選單筆 → 再顯示詳細內容 */
    onListSelect(row) {
      this.showDetail(row, this.listDialog.detailTitle);
    },
    /* 編輯既有公告（與新增共用同一個編輯 Dialog） */
    openEditAnn(item, target) {
      const [y, m, d] = item.date.split('-').map(Number);
      this.form = { date: `${y}/${m}/${d}`, content: item.title };
      this.editingId = item._id || '';
      this.dialogEditTarget = target;
      this.editDialogVisible = true;
    },

    loadAll(){
      this.loadProcessList();
      this.loadSoftwareList();
      this.loadNoticeList();
    },

    async loadProcessList(){
      console.log('loadProcessList');
      let res = await this.$axios({
        category: 'user',
        method: 'get',
        apiName: `loadProcessList?days=-1&project_id=${this.selectedProject._id}`,
      });
      console.log(res.data);
      this.processTable = res.data.map(ele=>{
        return {
          _id: ele._id,
          title: ele.content,
          date: ele.TIMESTAMP.split('T')[0],
        };
      });
    },

    async loadSoftwareList(){
      console.log('loadSoftwareList');
      let res = await this.$axios({
        category: 'user',
        method: 'get',
        apiName: 'loadSoftwareList?days=-1',
      });
      console.log(res.data);
      this.softwareTable = res.data.map(ele=>{
        return {
          _id: ele._id,
          title: ele.content,
          date: ele.TIMESTAMP.split('T')[0],
        };
      });
    },

    async loadNoticeList(){
      console.log('loadNoticeList');
      let res = await this.$axios({
        category: 'user',
        method: 'get',
        apiName: 'loadNoticeList?days=-1',
      });
      console.log(res.data);
      this.noticeTable = res.data.map(ele=>{
        return {
          title: ele.content,
          date: ele.TIMESTAMP.split('T')[0],
        };
      });
    },

    async handleUpload(){
      console.log('handleUpload', this.dialogEditTarget);

      // 後端限制 content（含 Quill 產生的 HTML 標籤）最長 NOTICE_CONTENT_MAX 字
      const contentLength = (this.form.content || '').length;
      if (contentLength > NOTICE_CONTENT_MAX) {
        this.$notifyError(`內容過長（${contentLength} / ${NOTICE_CONTENT_MAX} 字，含格式標籤），請精簡後再上傳`);
        return;
      }

      this.uploading = true;

      try{
        const isEdit = !!this.editingId;
        const data = {
          content: this.form.content,               // 對應 Notice.content
          timestamp: this.toISO(this.form.date),       // 對應 Notice.TIMESTAMP
          project_id: this.selectedProject._id,
        };
        if (isEdit) data._id = this.editingId;

        await this.$axios({
          category: 'user',
          method: 'post',
          apiName: (isEdit ? this.updateApiDict : this.apiDict)[this.dialogEditTarget],
          data,
        });

        this.form.content = '';
        this.form.date    = '';
        this.editingId    = '';
        if (isEdit) this.editDialogVisible = false;

        await this.loadAll();
        this.$notifySuccess(isEdit ? '更新成功' : '上傳成功');
      }
      catch(e){
        const res = e && e.response;
        // 401／帳號停用已由 axios 層提示，其餘 400 顯示後端訊息，讓使用者知道被擋的原因
        if (res && res.status === 400) {
          this.$notifyError((res.data && res.data.message) || '送出的資料格式不正確');
        } else if (!res || res.status !== 401) {
          this.$notifyError('上傳失敗');
        }
        console.error(e);
      }

      this.uploading = false;
    },

    /** 將日期字串轉成 ISO (後端若可吃字串可省) */
    toISO(dateStr) {
      // dateStr 格式 "YYYY/M/D" → new Date("YYYY-MM-DD")
      const [y, m, d] = dateStr.split('/');
      return new Date(`${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`);
    },

    /**
     * 把字串裡的 HTML 標籤全部移除
     * @param {string} str - 含 HTML 的原始字串
     * @returns {string} - 已去標籤的乾淨字串
     */
    stripHtmlTags(str) {
      return str.replace(/<\/?[^>]+>/g, '');
    },
  },
};
</script>

<style scoped>

.Time {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: black;
}

.abnormal-page {
  background-color: #fff;
  font-family: 'Noto Sans TC', sans-serif;
}

.page-header {
  background-color: #fff;
  padding: 10px 20px;
  border-bottom: 1px solid #ccc;
}

.header-row {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.header-title {
  font-size: 18px;
  font-weight: bold;
}

.page-main {
  padding: 20px;
}

.info-stack > .info-block {
  margin-bottom: 20px;
}

.block-title {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 10px;
  border-bottom: 1px dashed #aaa;
  padding-bottom: 4px;
}

.new-tag {
  color: red;
  font-size: 12px;
  margin-left: 6px;
}

.radio-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.checkbox-group {
  margin-bottom: 10px;
}

.instrument-table .el-table__cell {
  text-align: center;
}
/* 建議放到同一檔 style 區塊；scoped 或全域皆可 */
.block-title {
  display: flex;              /* ↖ 讓左右排列 */
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 8px;         /* 與 ul 做間距 */
}

.new-btn {
  padding: 10px;            /* 微調內距 */
}

.process-alert {
  max-width: 260px;               /* 跟截圖差不多大小 */
}
.process-alert .el-message-box__header {
  background: #e4e6ea;
  border-bottom: none;
  padding: 10px 16px 6px;
}
.process-alert .el-message-box__title {
  font-weight: 600;
}
.process-alert .el-message-box__content {
  background: #e4e6ea;
  padding: 6px 16px 16px;
}
.process-alert .el-message-box__btns {
  display: none;                  /* 只有右上角 X，不要下方按鈕 */
}
</style>

<!-- $alert 產生的節點不在元件內，scoped 無效，需使用全域樣式 -->
<style>
.rich-alert.el-message-box {
  width: min(90vw, 640px);
  max-width: 640px;
}
.rich-alert .el-message-box__content {
  max-height: 60vh;
  overflow-y: auto;
}
.rich-alert .rich-content {
  line-height: 1.7;
  word-break: break-word;
}
.rich-alert .rich-content p { margin: 0; }
.rich-alert .rich-content .ql-align-center { text-align: center; }
.rich-alert .rich-content .ql-align-right { text-align: right; }
.rich-alert .rich-content .ql-align-justify { text-align: justify; }
</style>

<style lang="scss" scoped>
/* ===== Dialog 造型 ===== */
.process-create-dialog {
  /* header + body 同色 */
  .el-dialog__header,
  .el-dialog__body {
    background: #efefef;
    padding: 10px 12px;
    max-height: 70vh;          /* 整個 body 最多佔 70% 螢幕高，必要時可捲軸 */
    overflow-y: auto;
  }

  .dialog-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .label {
    font-weight: 600;
  }
  .actions {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .close-x {
    font-size: 22px;
    cursor: pointer;
    color: #555;
  }

  /* 編輯器外框與大小 */
  .editor {
    min-height: 600px;
    max-height: 60vh;
    /* 如果已經把 Quill 內層邊框拔掉，這一層外框 border 可以保留美觀 */
    border: 1px solid #c0c4cc; 
  }
  .editor .ql-container {
    height: 100% !important;   /* 回復原本的 100% */
    overflow-y: auto;          /* 內容過長時出現捲軸 */
  }
  ::v-deep .editor .ql-container.ql-snow {
    border: 0 !important;     // 完全拿掉
  }

  .header-left {
    display: flex;
    align-items: center;
    gap: 8px;        /* 標籤與 date-picker 間距 */
    flex: 1;         /* 吃滿剩餘寬度，把 actions 推到最右 */
  }
}

.process-list-dialog {
  .el-dialog__header,
  .el-dialog__body {
    background: #dcdde1;   // 與之前一樣的灰底
    padding: 10px;
  }

  .list-title {
    font-weight: 700;
    font-size: 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      font-size: 14px;
      font-weight: 400;
    }
  }

  .close-x {
    font-size: 22px;
    cursor: pointer;
    color: #333;
  }

  /* 讓 index 欄置中更好看 */
  ::v-deep .el-table th,
  ::v-deep .el-table td {
    text-align: center;
  }
}

.dotted-list {
  list-style: none;
  margin: 0;
  padding: 0;

  /* ➜ 每一列 */
  .list-item {
    display: flex;               /* 讓左右同一行 */
    align-items: flex-start;     /* 日期頂對齊 */
    border-bottom: 1px dashed #ccc;
    padding: 6px 0;
  }

  /* ➜ 標題 (可換行、最多兩行省略) */
  .rich-title {
    flex: 1 1 auto;              /* 吃滿剩餘寬度 */
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  /* ➜ 日期 (靠右、不換行) */
  .date {
    margin-left: 12px;           /* 與標題留點距離 */
    font-size: 12px;
    color: #999;
    white-space: nowrap;
  }
}
</style>